import React from 'react'
import { Link } from 'react-router-dom'

import project1 from '../../../assets/project1.png'
import project2 from '../../../assets/project2.png'
import project3 from '../../../assets/project3.png'
import project_bg from '../../../assets/ww.png'

const HomeProjects = () => {
	const projects = [
		{
			id: 1,
			image: project1,
			category: 'Movie',
			title: 'Power of Africa',
			description:
				'A movie about the power struggles in Africa, just after the colonial era...',
			percentage: 100,
			status: 'Project Funded',
		},
		{
			id: 2,
			image: project2,
			category: 'Movie',
			title: 'Traditional Sisters',
			description:
				'Contrary to popular belief, Lorem Ipsum is not simply random text...',
			percentage: 100,
			status: 'Project Funded',
		},
		{
			id: 3,
			image: project3,
			category: 'Short Stories',
			title: 'Shadow Queen',
			description:
				'Contrary to popular belief, Lorem Ipsum is not simply random text...',
			percentage: 50,
			status: 'Project in Funding',
		},
	]

	return (
		<section
			className='homepage_projects'
			style={{ background: `url(${project_bg})` }}
		>
			<div className='container'>
				<div className='row'>
					<div className='col-md-12 text-center'>
						<h3 className='section_header'>Projects</h3>
					</div>

					<div className='homepage_projects_padbox'>
						<div className='row'>
							{projects.map((project) => (
								<div
									className='col-md-4 col-sm-6 p-4 ml-auto mr-auto'
									key={project.id}
								>
									<div className='homepage_projects_box'>
										<Link to='/projects/1'>
											<img src={project.image} alt='' />
										</Link>
										<div className='homepage_projects_card'>
											<p className='project_category project_category_abs'>
												{project.category}
											</p>
											<h5> {project.title} </h5>
											<p className='project_desc'>{project.description}</p>
											{/* <progress id='file' value={project.percentage} max='100'>
												{project.percentage}
											</progress> */}
											<p className='text-left project_desc'>{project.status}</p>

											<Link
												to='/projects/1'
												className='project_category ml-auto btn'
											>
												View
											</Link>
										</div>
									</div>
								</div>
							))}
						</div>
					</div>
				</div>
			</div>
		</section>
	)
}

export default HomeProjects
